import { render, staticRenderFns } from "./CompilationsDrag.vue?vue&type=template&id=685a1b1d"
import script from "./CompilationsDrag.vue?vue&type=script&lang=js"
export * from "./CompilationsDrag.vue?vue&type=script&lang=js"
import style0 from "./CompilationsDrag.vue?vue&type=style&index=0&id=685a1b1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports